var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.153,
    height: 14.779,
    viewBox: "0 0 16.153 14.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "double_arrow",
    transform: "translate(7870.558 15059.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-keyboard-arrow-right",
    "data-name": "Icon material-keyboard-arrow-right",
    d: "M12.885,21.668l5.641-5.653-5.641-5.653,1.737-1.737,7.39,7.39-7.39,7.39Z",
    transform: "translate(-7876.416 -15068.404)",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-keyboard-arrow-right-2",
    "data-name": "Icon material-keyboard-arrow-right",
    d: "M12.885,21.668l5.641-5.653-5.641-5.653,1.737-1.737,7.39,7.39-7.39,7.39Z",
    transform: "translate(-7883.442 -15068.404)",
    fill: "#787878"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double_arrow.0504a82c672e49da156df0d45d79b0aa.svg";
export { ForwardRef as ReactComponent };